import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-submittals-wrapper',
    templateUrl: './submittals-wrapper.component.html',
    styleUrls: ['./submittals-wrapper.component.scss'],
    standalone: false
})
export class SubmittalsWrapperComponent implements OnInit, OnDestroy {
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
